import React from "react";
import PropTypes from "prop-types";
import "@reach/tabs/styles.css";
import Text from "@tds/core-text";
import Link from "@tds/core-link";
import { withTranslation } from "react-i18next";
import Page from "../components/Page";
import "../../../css/dist/verified.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NotFound from "../components/NotFound";
import utils from "../utils";

function splashPage(props) {
  const { t, i18n } = props;

  const changeLanguage = (e, langCode) => {
    e.preventDefault();
    i18n.changeLanguage(langCode);
  };
  const sbs = utils.getUrlVar("sbs");

  const sbsContent = (
    <>
      <Text size="large">{t("sbsSplash.content")}</Text>
      <Text size="large">{t("sbsSplash.contactText")}</Text>
      <Text size="large">
        <Text bold>{t("sbsSplash.contactHeading")}</Text>
        <br />
        <Link href="tel:+18665061226">1-866-506-1226</Link>
      </Text>
    </>
  );

  return (
    <Page>
      <Header
        title={t("headerTitle")}
        telusSiteText={t("headerTelusSiteText")}
        currentLanguage={i18n.language}
        changeLanguageCallback={changeLanguage}
      />
      {sbs === undefined ? (
        <NotFound content={t("splashText")} />
      ) : (
        <NotFound>{sbsContent}</NotFound>
      )}

      <Footer />
    </Page>
  );
}

splashPage.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string,
    changeLanguage: PropTypes.func,
  }).isRequired,
};

export default withTranslation()(splashPage);
